const ClickAndCollectIcon = () => {
  return (
    <svg
      style={{
        width: "2rem",
        height: "2rem",
      }}
      focusable="false"
      class="pub__svg-icon c21nsg2"
      aria-hidden="true"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21 4H1v16h15V10H6v8H3V6h16v7.1707c-1.1652.4118-2 1.5231-2 2.8293v3c0 1.6569 1.3431 3 3 3s3-1.3431 3-3v-3c0-1.3062-.8348-2.4175-2-2.8293V4zM8 18h2v-6H8v6zm6 0h-2v-6h2v6zm5-2c0-.5523.4477-1 1-1s1 .4477 1 1v3c0 .5523-.4477 1-1 1s-1-.4477-1-1v-3z"
      ></path>
    </svg>
  );
};
export default ClickAndCollectIcon;
